import { render } from "./ParentView.vue?vue&type=template&id=bd642bf4&ts=true"
import script from "./ParentView.vue?vue&type=script&lang=ts"
export * from "./ParentView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__